<p style="padding: 24px;">Redirecting to the login page...</p>